import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type FlowRequest = {
  clientId?: string;
  checkTypes: string[];
  successUrl: string;
  cancelUrl: string;
  enableMonitoring?: boolean;
  allowDocumentUpload?: boolean;
  supportEmail?: string;
  language?: string;
  theme?: string;
  messages?: object;
  documentTypes?: object;
};

export type FlowSession = {
  redirectUrl: string;
};

export class Flow extends Resource<FlowRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("flow/sessions", axiosInstance);
  }

  public async createSession(
    clientId: string,
    flowRequest: FlowRequest
  ): Promise<FlowSession> {
    return this.request({
      method: Method.POST,
      body: { clientId, ...flowRequest }
    });
  }
}
